import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export type WaitlistTargetType = 'unit' | 'floorplan';

@Injectable({
  providedIn: 'root', // globally available
})
export class WaitlistService {
  private baseUrl = `${environment.baseUrl}waitlist`;

  constructor(private http: HttpClient) {}

  /**
   * Get waitlist users for a unit or floorplan
   * @param type 'unit' | 'floorplan'
   * @param id the unit or floorplan ID
   */
  getWaitlistByTarget(type: WaitlistTargetType, id: string): Observable<any> {
    return this.http.get(`${this.baseUrl}/${type}/${id}`);
  }

  /**
   * Add a user to waitlist (works for unit or floorplan)
   * payload must include:
   * - property_id: string
   * - unit_id?: string
   * - floor_plan_id?: string
   * - name: string
   * - email: string
   * - phone?: string
   * - source: 'Chatbot' | 'Textbot' | 'Admin'
   */
  addToWaitlist(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}`, payload);
  }

  /**
   * Optionally, get all waitlist entries (for admin dashboard)
   */
  getAllWaitlist(queryParams?: any): Observable<any> {
    const queryString = queryParams
      ? '?' + new URLSearchParams(queryParams).toString()
      : '';
    return this.http.get(`${this.baseUrl}${queryString}`);
  }

  /**
   * Optionally, update waitlist status (activate/deactivate)
   */
  updateWaitlistStatus(waitlistId: string, is_active: boolean): Observable<any> {
    return this.http.patch(`${this.baseUrl}/${waitlistId}`, { is_active });
  }
}